<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 text-left py-2>
        <span
          style="font-family: opensansbold; font-size: 14px; color: #808080"
        >
          Top Selling Products
        </span>
      </v-flex>
      <v-flex xs12 py-2 v-for="(item, i) in storage" :key="i">
        <v-card flat rounded="xl" color="#F5F7FC" outlined>
          <v-layout px-4 wrap justify-center>
            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-flex xs3 sm2 pa-2 align-self-center>
                  <v-img
                    :src="mediaURL + item.product.photos[0]"
                    height="80px"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="#FF4343"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex pt-4 xs9 sm10 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm6>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <router-link
                            :to="'/Seller/Product/' + item.product._id"
                          >
                            <span
                              style="
                                font-family: opensansbold;
                                font-size: 16px;
                                color: #808080;
                              "
                            >
                              {{ item.product.productname.slice(0, 25) }}
                              <span v-if="item.product.productname.length > 25">
                                ...
                              </span>
                            </span>
                          </router-link>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            Price: ₹{{ item.product.price }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Sale
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            ₹{{ item.total }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Today
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            ₹{{ item.today }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 16px;
                              color: #808080;
                            "
                          >
                            Item Sold
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: opensansbold;
                              font-size: 14px;
                              color: #000000;
                            "
                          >
                            {{ item.quantity }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage"],
  data() {
    return {};
  },
};
</script>